export const focusBody = () => {
  document.body.setAttribute('tabindex', '0');
  document.body.focus();
};

export const anyParentHasAttribute = (element: any, attrName: string, value?: string): boolean => {
  const selector = value ? `[${attrName}="${value}"]` : `[${attrName}]`;
  const tabindexAddedToParent = element.closest(selector);
  return tabindexAddedToParent && tabindexAddedToParent.tagName.toLowerCase() !== 'body';
};

export const anyParentHasTabIndex = (element: any, value?: string): boolean => {
  return anyParentHasAttribute(element, 'tabindex', value);
};

export const anyParentHasAriaLabel = (element: any, value?: string): boolean => {
  return anyParentHasAttribute(element, 'aria-label', value);
};
